import React from "react";
import style from "css/mypage.module.css";
import Dropbox from "components/mypagecomponents/dropbox";
import { useTranslation } from "react-i18next";
function Pastcard(props) {
  const { t } = useTranslation();
  const IsHover = true;
  return (
    <div
      className={style.pastbox + " cursor"}
      // onMouseOver={() => setIsHover(true)}
      // onMouseOut={() => setIsHover(false)}
      onClick={() => props.openpop(true, props.data.SCHEDULE_ID)}
    >
      <div className={style.itembox_header}>
        <div className={style.itembox_grey} />
        <div className={style.itembox_grey_text}>
          <img
            alt=""
            src={process.env.REACT_APP_CLIENT_URL + "img/mypage/star.png"}
            className={style.itembox_star}
          />
          {t("LABEL.MEETING_CLOSED")}
        </div>
      </div>
      <div className={style.pastbox_title}>{props.data.TITLE}</div>
      <div className={style.pastbox_time}>
        {props.data.START_TIME} - {props.data.END_TIME}
      </div>
      <div className={style.itembox_footer}>
        <div>
          {props.data.PARTICIPANTS !== "" ? (
            <Dropbox
              host={props.data.EMAIL}
              count={props.data.PARTICIPANTS.length}
              data={props.data}
              hover={IsHover}
            />
          ) : (
            <div />
          )}
        </div>

        <div
          className={
            IsHover
              ? style.itembox_endpointlist_hover
              : style.itembox_endpointlist
          }
        >
          {props.data.ENDPOINTLIST.length > 3 ? (
            props.data.ENDPOINT_LIST.map((data, index) => (
              <label key={index}>
                {data.ENDPOINT_NM}
                {props.data.ENDPOINT_LIST.length === index + 1 ? "" : ", "}
              </label>
            ))
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Pastcard;
